module.exports = __webpack_public_path__ + "img/borescope_protoype2.b59ff6a6.jpg";